import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'

export const useCheckModuleAcquired = (chargebeeModuleName: string) => {
  const { moduleAvailabilities } = useModuleAvailabilities()
  const modulesArray = chargebeeModuleName.split(',')
  const getAvailableModule = moduleAvailabilities.find((obj) => modulesArray.includes(obj.id))

  return getAvailableModule?.available ?? false
}
